import { isBeta, isLocal } from '../config/stage.ts';
import './BetaBanner.css';

export default function BetaBanner() {
  if (!isBeta && !isLocal) {
    return null;
  }
  const label = isLocal ? 'LOCAL' : 'BETA';
  return (
    <div className="om-beta-banner" role="status" aria-live="polite">
      <span className="om-beta-banner__chevron">▲</span>
      <span className="om-beta-banner__label">{label}</span>
      <span className="om-beta-banner__msg">non-production preview</span>
    </div>
  );
}
